import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { map } from 'rxjs/operators';
import { _SESION_RECHAZO } from '../../data/store/session/sesion.selectors';

export const rechazoGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(_SESION_RECHAZO).pipe(
    map(status => {
      if (status.rechazo) {
        return true;
      }
      return router.createUrlTree(['/']);
    })
  );
};
